import { IsoTimestampSchema } from "./string-validation"
import { z } from 'zod'

/**
 * Support Ticket Status Schema
 */
export const SupportTicketStatusSchema = z
  .enum(['open', 'pending', 'resolved'])
  .meta({ id: 'SupportTicketStatus' })

export type SupportTicketStatus = z.infer<typeof SupportTicketStatusSchema>

/**
 * Support Ticket Priority Schema
 */
export const SupportTicketPrioritySchema = z
  .enum(['low', 'medium', 'high', 'urgent'])
  .meta({ id: 'SupportTicketPriority' })

export type SupportTicketPriority = z.infer<typeof SupportTicketPrioritySchema>

/**
 * Support Ticket Schema
 */
export const SupportTicketSchema = z
  .object({
    id: z.string(),
    orderId: z.string(),
    patientId: z.string().optional(),
    patientName: z.string().optional(),
    status: SupportTicketStatusSchema,
    priority: SupportTicketPrioritySchema.optional(),
    subject: z.string().optional(),
    createdAt: IsoTimestampSchema,
    lastActivityAt: IsoTimestampSchema.optional(),
    slaDeadline: IsoTimestampSchema.optional(),
  })
  .meta({ id: 'SupportTicket' })

export type SupportTicket = z.infer<typeof SupportTicketSchema>

/**
 * Support Ticket Filters Schema
 */
export const SupportTicketFiltersSchema = z
  .object({
    status: SupportTicketStatusSchema.optional(),
    page: z.number().int().positive().default(1),
    limit: z.number().int().positive().max(100).default(50),
  })
  .meta({ id: 'SupportTicketFilters' })

export type SupportTicketFilters = z.infer<typeof SupportTicketFiltersSchema>
